module.exports = __webpack_public_path__ + "static/media/05_andinvainthedreamer.6440ab07.jpg";